/* CocoRock Combo Builder: one responsive selection surface, no modal state. */
(function () {
  'use strict';
  if (window.CocoRockComboBuilder) return;
  window.CocoRockComboBuilder = true;

  function money(cents, currency) {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || 'BRL' }).format((Number(cents) || 0) / 100); }
    catch (error) { return 'R$ ' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ','); }
  }

  function init(root) {
    if (!root || root.dataset.crBuilderReady) return;
    root.dataset.crBuilderReady = 'true';
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-cr-builder-flavor]'));
    var selection = root.querySelector('[data-cr-builder-selection]');
    var add = root.querySelector('[data-cr-builder-add]');
    var count = root.querySelector('[data-cr-builder-count]');
    var total = root.querySelector('[data-cr-builder-total]');
    var toast = root.querySelector('[data-cr-toast]');
    var media = root.querySelector('[data-cr-inline-media]');
    var cartbar = root.querySelector('[data-cr-cartbar]');
    var cartItems = root.querySelector('[data-cr-cart-items]');
    var cartTotal = root.querySelector('[data-cr-cart-total]');
    var viewCart = root.querySelector('[data-cr-view-cart]');
    var adding = false;
    var timer = 0;
    var viewLabel = viewCart ? viewCart.textContent.replace(/\s*\(\d+\)$/, '') : '';

    function quantity(row) { return parseInt(row.dataset.qty, 10) || 0; }
    function totals() {
      return rows.reduce(function (result, row) {
        var qty = quantity(row);
        result.units += qty;
        result.cents += qty * (parseInt(row.dataset.price, 10) || 0);
        return result;
      }, { units: 0, cents: 0 });
    }
    function render() {
      var value = totals();
      rows.forEach(function (row) {
        var qty = quantity(row);
        var out = row.querySelector('[data-cr-builder-qty]');
        var minus = row.querySelector('[data-cr-builder-minus]');
        if (out) out.textContent = qty;
        if (minus) minus.disabled = qty === 0 || row.classList.contains('is-unavailable');
        row.classList.toggle('has-items', qty > 0);
      });
      if (selection) selection.hidden = value.units === 0;
      root.classList.toggle('has-builder-selection', value.units > 0);
      if (count) count.textContent = value.units + (value.units === 1 ? ' item selecionado' : ' itens selecionados');
      if (total) total.textContent = money(value.cents, root.dataset.currency);
      if (add) {
        add.disabled = adding || value.units === 0;
        add.setAttribute('aria-busy', adding ? 'true' : 'false');
        add.textContent = adding ? 'Adicionando…' : 'Adicionar ao carrinho';
      }
    }
    function showToast(message) {
      if (!toast) return;
      clearTimeout(timer);
      toast.textContent = message;
      toast.hidden = false;
      requestAnimationFrame(function () { toast.classList.add('is-visible'); });
      timer = setTimeout(function () { toast.classList.remove('is-visible'); setTimeout(function () { toast.hidden = true; }, 220); }, 2600);
    }
    function selectProduct(card) {
      if (!card || !media) return;
      var image = media.querySelector('img');
      var title = media.querySelector('[data-cr-inline-title]');
      var price = media.querySelector('[data-cr-inline-price]');
      if (image && card.dataset.image) { image.src = card.dataset.image; image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.alt = card.dataset.title || ''; }
      if (title) title.textContent = card.dataset.title || '';
      if (price) price.textContent = card.dataset.price || '';
      root.querySelectorAll('[data-cr-inline-product]').forEach(function (item) { item.classList.toggle('is-selected', item === card); });
    }
    function updateCart(cart) {
      if (!cart) return;
      var units = Number(cart.item_count) || 0;
      if (cartbar) cartbar.hidden = units === 0;
      if (cartItems) cartItems.textContent = units + (units === 1 ? ' item' : ' itens');
      if (cartTotal) cartTotal.textContent = money(cart.total_price, root.dataset.currency);
      if (viewCart) viewCart.textContent = viewLabel + ' (' + units + ')';
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child').forEach(function (node) { node.textContent = units; node.hidden = units < 1; });
    }
    function submit() {
      var items = rows.map(function (row) { return { id: Number(row.dataset.variantId), quantity: quantity(row) }; }).filter(function (item) { return item.quantity > 0; });
      if (!items.length || adding) return;
      if (!window.CocoRockCart || typeof window.CocoRockCart.addItems !== 'function') { showToast('O carrinho ainda está carregando. Tente novamente.'); return; }
      adding = true; render();
      window.CocoRockCart.addItems(items, add, 'cr-combo-builder').then(function (cart) {
        rows.forEach(function (row) { row.dataset.qty = '0'; });
        adding = false; render(); updateCart(cart); showToast(root.dataset.addedMessage || 'Adicionado ao carrinho ✓');
      }).catch(function (error) { adding = false; render(); showToast((error && error.message) || 'Não foi possível adicionar. Tente novamente.'); });
    }
    root.addEventListener('click', function (event) {
      var plus = event.target.closest('[data-cr-builder-plus]');
      var minus = event.target.closest('[data-cr-builder-minus]');
      if (plus || minus) {
        var row = (plus || minus).closest('[data-cr-builder-flavor]');
        row.dataset.qty = String(Math.max(0, Math.min(99, quantity(row) + (plus ? 1 : -1))));
        selectProduct(row.closest('[data-cr-inline-product]')); render(); return;
      }
      var selector = event.target.closest('[data-cr-inline-select]');
      if (selector) { selectProduct(selector.closest('[data-cr-inline-product]')); return; }
      if (event.target.closest('[data-cr-builder-add]')) { submit(); return; }
      if (event.target.closest('[data-cr-view-cart]') && window.CocoRockCart) window.CocoRockCart.open(viewCart).catch(function () { showToast('Não foi possível abrir o carrinho.'); });
      if (event.target.closest('[data-cr-checkout]') && window.CocoRockCart) window.CocoRockCart.checkout(event.target.closest('[data-cr-checkout]'));
    });
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) { return response.ok ? response.json() : null; }).then(updateCart).catch(function () {});
    render();
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-cr-combo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
